namespace advisorop.components.widgets {

    export class HouseholdPivotController{
        accounts: any = null;
        householdId: number;
        accountGroupType: any;
        
        pgDs: DevExpress.data.PivotGridDataSourceOptions = {            
            fields: [
                { caption: "Household", width: 100, dataField: "householdName", area: "filter", wordWrapEnabled: true },
                { caption: "RTG", dataField: "rtName", width: 100, area: "row", expanded: true                    
                },
                {
                    caption: "Account", dataField: "accountName", area: "row",
                    selector: function (data: any) {
                        return data.accountName + " (" + data.accountNumber + ")";
                    }
                },
                { caption: "Account Type", width: 90, dataField: "AccountTypeDescription", area: "filter" },
                { caption: "Account Sleeve", dataField: "modelDescription", area: "row" },                
                { caption: "Security Asset Class", width: 90, dataField: "securityAssetClass", area: "filter"},
                { caption: "Security Type", width: 90, dataField: "securityType", area: "filter" },
                { caption: "Security Category", width: 90, dataField: "securityCategory", area: "filter" },
                { caption: "Security Symbol", width: 90, dataField: "securitySymbol", area: "filter"},

                { caption: "Market Value", dataField: "usdMarketValue", dataType: "number", summaryType: "sum", format: "currency", area: "data" }
            ],            
            store: this.accounts
        };

        pg: DevExpress.ui.dxPivotGridOptions = {
            allowSortingBySummary: true,
            allowSorting: true,
            allowFiltering: true,
            wordWrapEnabled: true,                                  
            fieldPanel: {
                showDataFields: true,
                showRowFields: true,
                showColumnFields: true,
                showFilterFields: true,
                allowFieldDragging: true,
                visible: true
            },
            showBorders: true,         
            bindingOptions: {
                dataSource: "vm.pgDs"
            },
            scrolling: {
                useNative: true
            },
            //useNativeScrolling: true,
            //rowHeaderLayout: "tree",            
            texts: {
                grandTotal: "$ Market value"
            }
        };
        

        static $inject = [`householdApi`]
        constructor(private hhApi: services.HouseholdApi) {            
        }

        $onInit(): void {            
        }

        loadHDAccounts(): void {
            this.hhApi.getAccountGroupsSummary(this.householdId, this.accountGroupType).then((data) => {

                this.accounts = data.data.gridData;

                this.pgDs.store = this.accounts;

                //this.onAccountsLoaded({ accounts: this.accounts });
            });
        };

        $onChanges(evt) {
            for (var key in evt) {
                if (key === "householdId" && this.householdId) {
                    this.loadHDAccounts();
                }

                if (key === "accounts") {
                    this.pgDs.store = this.accounts;
                }
            }
        };
        
    }



    class HouseholdPivot implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        //public $routeConfig: any;

        constructor() {
            this.bindings = {
                accounts: "<",
                householdId: "<",
                accountGroupType: "<"
            };
            this.controller = HouseholdPivotController;
            this.controllerAs = "vm";
            this.templateUrl = "spa/advisor-module/components/household-pivot.html";            
        }
    }
    angular.module(Constants.APP).component("householdPivot", new HouseholdPivot());
    
}